// Added by Sejune Oh on 2020-03-25
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Style
import { customStyles } from '@/components/worklist/TaskMonitoring/TaskMonitoringBox'

type ComponentTypes = 'taskmonitoringbox'

export type TaskMonitoringBoxStyleTypes = {
  [key in ComponentTypes]: Record<string, any>
}

export const TaskMonitoringBoxStyles: TaskMonitoringBoxStyleTypes = {
  taskmonitoringbox: customStyles,
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// ! Wrapper Component
export { default as TaskMonitoringBoxWrapper } from './TaskMonitoringBoxWrapper'
export * from './TaskMonitoringBoxWrapper'
